// Full hiragana + katakana dataset
// Each entry: { kana, romaji, group, order }

const HIRAGANA_BASE = [
  // Vowels
  { kana:'あ', romaji:'a',   group:'vowels',  order:1  },
  { kana:'い', romaji:'i',   group:'vowels',  order:2  },
  { kana:'う', romaji:'u',   group:'vowels',  order:3  },
  { kana:'え', romaji:'e',   group:'vowels',  order:4  },
  { kana:'お', romaji:'o',   group:'vowels',  order:5  },
  // K
  { kana:'か', romaji:'ka',  group:'k',       order:6  },
  { kana:'き', romaji:'ki',  group:'k',       order:7  },
  { kana:'く', romaji:'ku',  group:'k',       order:8  },
  { kana:'け', romaji:'ke',  group:'k',       order:9  },
  { kana:'こ', romaji:'ko',  group:'k',       order:10 },
  // S
  { kana:'さ', romaji:'sa',  group:'s',       order:11 },
  { kana:'し', romaji:'shi', group:'s',       order:12 },
  { kana:'す', romaji:'su',  group:'s',       order:13 },
  { kana:'せ', romaji:'se',  group:'s',       order:14 },
  { kana:'そ', romaji:'so',  group:'s',       order:15 },
  // T
  { kana:'た', romaji:'ta',  group:'t',       order:16 },
  { kana:'ち', romaji:'chi', group:'t',       order:17 },
  { kana:'つ', romaji:'tsu', group:'t',       order:18 },
  { kana:'て', romaji:'te',  group:'t',       order:19 },
  { kana:'と', romaji:'to',  group:'t',       order:20 },
  // N
  { kana:'な', romaji:'na',  group:'n',       order:21 },
  { kana:'に', romaji:'ni',  group:'n',       order:22 },
  { kana:'ぬ', romaji:'nu',  group:'n',       order:23 },
  { kana:'ね', romaji:'ne',  group:'n',       order:24 },
  { kana:'の', romaji:'no',  group:'n',       order:25 },
  // H
  { kana:'は', romaji:'ha',  group:'h',       order:26 },
  { kana:'ひ', romaji:'hi',  group:'h',       order:27 },
  { kana:'ふ', romaji:'fu',  group:'h',       order:28 },
  { kana:'へ', romaji:'he',  group:'h',       order:29 },
  { kana:'ほ', romaji:'ho',  group:'h',       order:30 },
  // M
  { kana:'ま', romaji:'ma',  group:'m',       order:31 },
  { kana:'み', romaji:'mi',  group:'m',       order:32 },
  { kana:'む', romaji:'mu',  group:'m',       order:33 },
  { kana:'め', romaji:'me',  group:'m',       order:34 },
  { kana:'も', romaji:'mo',  group:'m',       order:35 },
  // Y
  { kana:'や', romaji:'ya',  group:'y',       order:36 },
  { kana:'ゆ', romaji:'yu',  group:'y',       order:37 },
  { kana:'よ', romaji:'yo',  group:'y',       order:38 },
  // R
  { kana:'ら', romaji:'ra',  group:'r',       order:39 },
  { kana:'り', romaji:'ri',  group:'r',       order:40 },
  { kana:'る', romaji:'ru',  group:'r',       order:41 },
  { kana:'れ', romaji:'re',  group:'r',       order:42 },
  { kana:'ろ', romaji:'ro',  group:'r',       order:43 },
  // W
  { kana:'わ', romaji:'wa',  group:'w',       order:44 },
  { kana:'を', romaji:'wo',  group:'w',       order:45 },
  // N standalone
  { kana:'ん', romaji:'n',   group:'special', order:46 },
];

const HIRAGANA_DAKUTEN = [
  { kana:'が', romaji:'ga', group:'dakuten', order:47 },
  { kana:'ぎ', romaji:'gi', group:'dakuten', order:48 },
  { kana:'ぐ', romaji:'gu', group:'dakuten', order:49 },
  { kana:'げ', romaji:'ge', group:'dakuten', order:50 },
  { kana:'ご', romaji:'go', group:'dakuten', order:51 },
  { kana:'ざ', romaji:'za', group:'dakuten', order:52 },
  { kana:'じ', romaji:'ji', group:'dakuten', order:53 },
  { kana:'ず', romaji:'zu', group:'dakuten', order:54 },
  { kana:'ぜ', romaji:'ze', group:'dakuten', order:55 },
  { kana:'ぞ', romaji:'zo', group:'dakuten', order:56 },
  { kana:'だ', romaji:'da', group:'dakuten', order:57 },
  { kana:'ぢ', romaji:'ji', group:'dakuten', order:58 },
  { kana:'づ', romaji:'zu', group:'dakuten', order:59 },
  { kana:'で', romaji:'de', group:'dakuten', order:60 },
  { kana:'ど', romaji:'do', group:'dakuten', order:61 },
  { kana:'ば', romaji:'ba', group:'dakuten', order:62 },
  { kana:'び', romaji:'bi', group:'dakuten', order:63 },
  { kana:'ぶ', romaji:'bu', group:'dakuten', order:64 },
  { kana:'べ', romaji:'be', group:'dakuten', order:65 },
  { kana:'ぼ', romaji:'bo', group:'dakuten', order:66 },
];

const HIRAGANA_HANDAKUTEN = [
  { kana:'ぱ', romaji:'pa', group:'handakuten', order:67 },
  { kana:'ぴ', romaji:'pi', group:'handakuten', order:68 },
  { kana:'ぷ', romaji:'pu', group:'handakuten', order:69 },
  { kana:'ぺ', romaji:'pe', group:'handakuten', order:70 },
  { kana:'ぽ', romaji:'po', group:'handakuten', order:71 },
];

const KATAKANA_BASE = [
  // Vowels
  { kana:'ア', romaji:'a',   group:'vowels',  order:1  },
  { kana:'イ', romaji:'i',   group:'vowels',  order:2  },
  { kana:'ウ', romaji:'u',   group:'vowels',  order:3  },
  { kana:'エ', romaji:'e',   group:'vowels',  order:4  },
  { kana:'オ', romaji:'o',   group:'vowels',  order:5  },
  // K
  { kana:'カ', romaji:'ka',  group:'k',       order:6  },
  { kana:'キ', romaji:'ki',  group:'k',       order:7  },
  { kana:'ク', romaji:'ku',  group:'k',       order:8  },
  { kana:'ケ', romaji:'ke',  group:'k',       order:9  },
  { kana:'コ', romaji:'ko',  group:'k',       order:10 },
  // S
  { kana:'サ', romaji:'sa',  group:'s',       order:11 },
  { kana:'シ', romaji:'shi', group:'s',       order:12 },
  { kana:'ス', romaji:'su',  group:'s',       order:13 },
  { kana:'セ', romaji:'se',  group:'s',       order:14 },
  { kana:'ソ', romaji:'so',  group:'s',       order:15 },
  // T
  { kana:'タ', romaji:'ta',  group:'t',       order:16 },
  { kana:'チ', romaji:'chi', group:'t',       order:17 },
  { kana:'ツ', romaji:'tsu', group:'t',       order:18 },
  { kana:'テ', romaji:'te',  group:'t',       order:19 },
  { kana:'ト', romaji:'to',  group:'t',       order:20 },
  // N
  { kana:'ナ', romaji:'na',  group:'n',       order:21 },
  { kana:'ニ', romaji:'ni',  group:'n',       order:22 },
  { kana:'ヌ', romaji:'nu',  group:'n',       order:23 },
  { kana:'ネ', romaji:'ne',  group:'n',       order:24 },
  { kana:'ノ', romaji:'no',  group:'n',       order:25 },
  // H
  { kana:'ハ', romaji:'ha',  group:'h',       order:26 },
  { kana:'ヒ', romaji:'hi',  group:'h',       order:27 },
  { kana:'フ', romaji:'fu',  group:'h',       order:28 },
  { kana:'ヘ', romaji:'he',  group:'h',       order:29 },
  { kana:'ホ', romaji:'ho',  group:'h',       order:30 },
  // M
  { kana:'マ', romaji:'ma',  group:'m',       order:31 },
  { kana:'ミ', romaji:'mi',  group:'m',       order:32 },
  { kana:'ム', romaji:'mu',  group:'m',       order:33 },
  { kana:'メ', romaji:'me',  group:'m',       order:34 },
  { kana:'モ', romaji:'mo',  group:'m',       order:35 },
  // Y
  { kana:'ヤ', romaji:'ya',  group:'y',       order:36 },
  { kana:'ユ', romaji:'yu',  group:'y',       order:37 },
  { kana:'ヨ', romaji:'yo',  group:'y',       order:38 },
  // R
  { kana:'ラ', romaji:'ra',  group:'r',       order:39 },
  { kana:'リ', romaji:'ri',  group:'r',       order:40 },
  { kana:'ル', romaji:'ru',  group:'r',       order:41 },
  { kana:'レ', romaji:'re',  group:'r',       order:42 },
  { kana:'ロ', romaji:'ro',  group:'r',       order:43 },
  // W
  { kana:'ワ', romaji:'wa',  group:'w',       order:44 },
  { kana:'ヲ', romaji:'wo',  group:'w',       order:45 },
  // N standalone
  { kana:'ン', romaji:'n',   group:'special', order:46 },
];

const KATAKANA_DAKUTEN = [
  { kana:'ガ', romaji:'ga', group:'dakuten', order:47 },
  { kana:'ギ', romaji:'gi', group:'dakuten', order:48 },
  { kana:'グ', romaji:'gu', group:'dakuten', order:49 },
  { kana:'ゲ', romaji:'ge', group:'dakuten', order:50 },
  { kana:'ゴ', romaji:'go', group:'dakuten', order:51 },
  { kana:'ザ', romaji:'za', group:'dakuten', order:52 },
  { kana:'ジ', romaji:'ji', group:'dakuten', order:53 },
  { kana:'ズ', romaji:'zu', group:'dakuten', order:54 },
  { kana:'ゼ', romaji:'ze', group:'dakuten', order:55 },
  { kana:'ゾ', romaji:'zo', group:'dakuten', order:56 },
  { kana:'ダ', romaji:'da', group:'dakuten', order:57 },
  { kana:'ヂ', romaji:'ji', group:'dakuten', order:58 },
  { kana:'ヅ', romaji:'zu', group:'dakuten', order:59 },
  { kana:'デ', romaji:'de', group:'dakuten', order:60 },
  { kana:'ド', romaji:'do', group:'dakuten', order:61 },
  { kana:'バ', romaji:'ba', group:'dakuten', order:62 },
  { kana:'ビ', romaji:'bi', group:'dakuten', order:63 },
  { kana:'ブ', romaji:'bu', group:'dakuten', order:64 },
  { kana:'ベ', romaji:'be', group:'dakuten', order:65 },
  { kana:'ボ', romaji:'bo', group:'dakuten', order:66 },
];

const KATAKANA_HANDAKUTEN = [
  { kana:'パ', romaji:'pa', group:'handakuten', order:67 },
  { kana:'ピ', romaji:'pi', group:'handakuten', order:68 },
  { kana:'プ', romaji:'pu', group:'handakuten', order:69 },
  { kana:'ペ', romaji:'pe', group:'handakuten', order:70 },
  { kana:'ポ', romaji:'po', group:'handakuten', order:71 },
];

export const HIRAGANA = [...HIRAGANA_BASE, ...HIRAGANA_DAKUTEN, ...HIRAGANA_HANDAKUTEN];
export const KATAKANA = [...KATAKANA_BASE, ...KATAKANA_DAKUTEN, ...KATAKANA_HANDAKUTEN];

export const GROUPS = ['vowels','k','s','t','n','h','m','y','r','w','special','dakuten','handakuten'];

export const GROUP_LABELS = {
  vowels:  'Vowels',
  k:       'K row',
  s:       'S row',
  t:       'T row',
  n:       'N row',
  h:       'H row',
  m:       'M row',
  y:       'Y row',
  r:       'R row',
  w:       'W row',
  special: 'Special',
  dakuten: 'Dakuten',
  handakuten: 'Handakuten',
};
